/**
 * @generated SignedSource<<67ac3fe1e80414e87f192019f6f1bc49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UnitSchoolGradeEnum = "five" | "four" | "high" | "highest" | "low" | "lowest" | "medium" | "one" | "seven" | "six" | "three" | "two" | "zero" | "%future added value";
export type TaskMigrateDialog_difficultyGradesQuery$variables = {
  id: string;
  unitDs: ReadonlyArray<string>;
};
export type TaskMigrateDialog_difficultyGradesQuery$data = {
  readonly task: {
    readonly id: string;
    readonly migrationDifficultyGrades: ReadonlyArray<UnitSchoolGradeEnum>;
  };
};
export type TaskMigrateDialog_difficultyGradesQuery = {
  response: TaskMigrateDialog_difficultyGradesQuery$data;
  variables: TaskMigrateDialog_difficultyGradesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "unitDs"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Task",
    "kind": "LinkedField",
    "name": "task",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "unitDs",
            "variableName": "unitDs"
          }
        ],
        "kind": "ScalarField",
        "name": "migrationDifficultyGrades",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskMigrateDialog_difficultyGradesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskMigrateDialog_difficultyGradesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d56623499fcf998c8c5306015a0fcb99",
    "id": null,
    "metadata": {},
    "name": "TaskMigrateDialog_difficultyGradesQuery",
    "operationKind": "query",
    "text": "query TaskMigrateDialog_difficultyGradesQuery(\n  $id: ID!\n  $unitDs: [ID!]!\n) {\n  task(id: $id) {\n    id\n    migrationDifficultyGrades(unitDs: $unitDs)\n  }\n}\n"
  }
};
})();

(node as any).hash = "02680b80670e4545ab7d05121444b964";

export default node;
